import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

const DEFAULT = '/coach/performance/Badminton/skill-assessment-beginner-self';

/** Redirect legacy coach-as-player self evaluation / player-performance URLs to unified Training Evaluation. */
const CoachSelfPerformanceLegacyRedirect: React.FC = () => {
  const { metric } = useParams<{ metric?: string }>();
  if (!metric) {
    return <Navigate to={DEFAULT} replace />;
  }
  return <Navigate to={DEFAULT} replace />;
};

export default CoachSelfPerformanceLegacyRedirect;
